<mat-form-field class="w-100">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [value]="value"
    (selectionChange)="onSelectionChange($event.value)"
    (blur)="onTouched()"
    [disabled]="disabled"
    [required]="isRequired"
    [errorStateMatcher]="errorStateMatcher"
  >
    @for (nationality of nationalityList; track nationality.code) {
      <mat-option [value]="nationality.code">
        <span class="option-content" [class.with-flag]="showFlag">
          @if (showFlag) {
            <span class="option-flag fi fi-{{ nationality.code.toLowerCase() }}"></span>
          }
          <span class="nationality-name">{{ nationality.name }}</span>
        </span>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
